module.exports = __webpack_public_path__ + "img/aws.8a7f511c.png";